import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { setDoc, doc } from "firebase/firestore";
import { auth, db } from "./firebase";
import "./Signup.css";
import loginImage from "./login.png";

const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      console.log("User Registered Successfully:", user);

      // Save additional user info in Firestore
      await setDoc(doc(db, "users", user.uid), {
        firstName: fname,
        lastName: lname,
        email: email,
      });

      console.log("User data saved in Firestore");
    } catch (error) {
      console.log("Error:", error.message);
    }
  };

  return (
    <div className="login-container">
      <div className="image-section">
        <img src={loginImage} alt="Login Illustration" />
      </div>
      <div className="login-section">
        <h1>Transforming <br /> Your Business Outlook</h1>
        <p>Sign up and show how you can change your outlook towards your career</p>
        <div className="social-login">
          <button className="google-btn">
            Sign up with Google
          </button>
          <button className="linkedin-btn">
            Sign up with LinkedIn
          </button>
        </div>
        <div className="divider">
          <hr className="dividerline" />
          <span className="dividertext">OR</span>
          <hr className="dividerline" />
        </div>
        <form className="login-form" onSubmit={handleRegister}>
          <div className="namegroup">
            <div className="Firstnamegroup">
              <h5>NAME</h5>
              <input
                type="text"
                placeholder="Enter your First Name"
                value={fname}
                onChange={(e) => setFname(e.target.value)}
                required
              />
            </div>
            <div className="Lastnamegroup">
              <h5>Last NAME</h5>
              <input
                type="text"
                placeholder="Enter your Last Name"
                value={lname}
                onChange={(e) => setLname(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="emailgroup">
            <h5>EMAIL ADDRESS</h5>
            <input
              type="email"
              placeholder="Enter your Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="passwordgroup">
            <h5>PASSWORD</h5>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit">Create Account</button>
        </form>
      </div>
    </div>
  );
}

export default Signup;
